module.exports = __webpack_public_path__ + "static/img/new-item-bg.b95eb8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-item-bg.png
// module id = eVjq
// module chunks = 1